<mat-card>
  <mat-card-header>
    <mat-card-title>Delete Failed</mat-card-title>
  </mat-card-header>
  <mat-card-content class="failurecontent">
    {{data.message | translate}}
  <ul>
    <li *ngFor="let report of data.linkedReports"><b>{{report.reportName}}</b> in <b>{{report.organizationName}}</b></li>
  </ul>
</mat-card-content>

<mat-card-actions>
  <button mat-button color="warn" [mat-dialog-close]="true">{{ 'General.Ok' | translate }}</button>
</mat-card-actions>
</mat-card>


 